import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "form-loading" }
const _hoisted_2 = {
  key: 0,
  class: "form-header"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.formError)
    ? (_openBlock(), _createBlock($setup["formLoadError"], { key: 0 }))
    : ($setup.FormState === 'Loading' || $setup.FormState === 'Setup')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Loader for the form "),
          _createElementVNode("div", _hoisted_1, [
            _createVNode($setup["loaderDark"]),
            _cache[13] || (_cache[13] = _createElementVNode("p", null, " Loading Content", -1 /* CACHED */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : ($setup.FormState === 'RegularForm')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _renderSlot(_ctx.$slots, "heading", {}, () => [
              (!$setup.disableFormHeading)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString($setup.formHeading ? $setup.formHeading : $setup.translate("contact-Heading", {ns: $setup.TranslationNamespaceEnum.formHeadingText})), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("form", _mergeProps({
              ref: "formElRef",
              class: ["eclipse-form", $setup.FormClasses.marketoFormClass]
            }, _ctx.$attrs, { "data-testid": "form-root" }), [
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.FirstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.userInputValues.FirstName) = $event)),
                "input-state": $setup.inputStates.FirstName,
                "form-input-meta": $setup.FormInputsMeta.FirstName
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.LastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.userInputValues.LastName) = $event)),
                "input-state": $setup.inputStates.LastName,
                "form-input-meta": $setup.FormInputsMeta.LastName
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.userInputValues.Email) = $event)),
                "input-state": $setup.inputStates.Email,
                "form-input-meta": $setup.FormInputsMeta.Email
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]),
              _renderSlot(_ctx.$slots, "middleHeading"),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Company,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.userInputValues.Company) = $event)),
                "input-state": $setup.inputStates.Company,
                "form-input-meta": $setup.FormInputsMeta.Company
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Country,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.userInputValues.Country) = $event)),
                "input-state": $setup.inputStates.Country,
                "form-input-meta": $setup.FormInputsMeta.Country,
                "dropdown-option-keys": $setup.FormOptions.Country,
                "dropdown-translations-namespace": "countries"
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta", "dropdown-option-keys"]),
              _createVNode($setup["stateOrTerritorySelector"], {
                modelValue: $setup.userInputValues.State,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.userInputValues.State) = $event)),
                "input-state": $setup.inputStates.State,
                "form-input-meta": $setup.FormInputsMeta.State,
                "dropdown-option-keys": $setup.FormOptions.State,
                "dropdown-translations-namespace": "states"
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta", "dropdown-option-keys"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Phone,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.userInputValues.Phone) = $event)),
                "input-state": $setup.inputStates.Phone,
                "form-input-meta": $setup.FormInputsMeta.Phone
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Tier__c,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.userInputValues.Tier__c) = $event)),
                "input-state": $setup.inputStates.Tier__c,
                "form-input-meta": $setup.FormInputsMeta.Tier__c,
                "dropdown-option-keys": $setup.FormOptions.Tier__c,
                "dropdown-translations-namespace": "company-sizes"
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta", "dropdown-option-keys"]),
              _createVNode($setup["eclipseInput"], {
                modelValue: $setup.userInputValues.Industry,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.userInputValues.Industry) = $event)),
                "input-state": $setup.inputStates.Industry,
                "form-input-meta": $setup.FormInputsMeta.Industry,
                "dropdown-option-keys": $setup.FormOptions.Industry,
                "dropdown-translations-namespace": "industries"
              }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta", "dropdown-option-keys"]),
              ($setup.isFieldEnabled('Latest_Solution_Interest__c'))
                ? (_openBlock(), _createBlock($setup["mainSolutionInterestInput"], {
                    key: 0,
                    modelValue: $setup.userInputValues.Latest_Solution_Interest__c,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.userInputValues.Latest_Solution_Interest__c) = $event)),
                    "input-state": $setup.inputStates.Latest_Solution_Interest__c,
                    "form-input-meta": $setup.FormInputsMeta.Latest_Solution_Interest__c,
                    "disable-qualer": $setup.disableQualer
                  }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]))
                : _createCommentVNode("v-if", true),
              ($setup.isFieldEnabled('Webform_Comments_recent_value__c'))
                ? (_openBlock(), _createBlock($setup["eclipseInput"], {
                    key: 1,
                    modelValue: $setup.userInputValues.Webform_Comments_recent_value__c,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.userInputValues.Webform_Comments_recent_value__c) = $event)),
                    "input-state": $setup.inputStates.Webform_Comments_recent_value__c,
                    "form-input-meta": $setup.FormInputsMeta.Webform_Comments_recent_value__c
                  }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta"]))
                : _createCommentVNode("v-if", true),
              _createVNode($setup["emailOptInCheckbox"], {
                modelValue: $setup.userInputValues.Email_Opt_In__c,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.userInputValues.Email_Opt_In__c) = $event)),
                "form-input-meta": $setup.FormInputsMeta.Email_Opt_In__c,
                "input-state": $setup.inputStates.Email_Opt_In__c,
                "marketo-input-name": $setup.FormInputsMeta.Email_Opt_In__c.marketoName
              }, null, 8 /* PROPS */, ["modelValue", "form-input-meta", "input-state", "marketo-input-name"]),
              _createCommentVNode(" Eclipse Submit Button "),
              _createVNode($setup["submitButton"], {
                onSubmitForm: _cache[12] || (_cache[12] = $event => ($setup.submitForm()))
              }, {
                default: _withCtx(() => [
                  ($setup.ctaButtonText)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString($setup.ctaButtonText), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString($setup.translate($setup.buttonTextMapKey, { ns: $setup.TranslationNamespaceEnum.submitButtonText })), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              })
            ], 16 /* FULL_PROPS */)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
}